
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/statics/[...slug]",
      function () {
        return require("private-next-pages/statics/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/statics/[...slug]"])
      });
    }
  